<template>
    <div class="FormDate" @keyup.capture="updateValue"  id="calendar">
        <input v-if="showDay" ref="day" v-model="day" class="FormDate__input FormDate__input--day" type="number" placeholder="dd" @input="updateDay" @blur="day = day.padStart(2, 0) ;  blurFunc()" />
        <span v-if="showDay && showMonth" class="FormDate__divider">/</span>

        <input v-if="showMonth" ref="month" v-model="month" class="FormDate__input FormDate__input--month" :type="monthType" placeholder="mm" @input="updateMonth"   @blur="month = month.padStart(2, 0)"  />

        <span v-if="showYear && (showDay || showMonth)" class="FormDate__divider">/</span>
        <input v-if="showYear" ref="year" v-model="year" class="FormDate__input FormDate__input--year" type="number" placeholder="yyyy"  @input="updateYear" @blur="year = year.padStart(4, 0) ; blurFunc()" />
    </div>
</template>

<script>
    export default {
        name: `FormDate`,
        props: {
            value: {
                type: [Number, String],
                required: true,
            },
            showDay: {
                type: Boolean,
                default: true,
            },
            showMonth: {
                type: Boolean,
                default: true,
            },
            showYear: {
                type: Boolean,
                default: true,
            },

           
        },
        data() {
            return {
                day: `${this.value ? new Date(this.value).getDate() : ``}`,
                month: `${this.value ? new Date(this.value).getMonth() + 1 : ``}`,
                year: `${this.value ? new Date(this.value).getFullYear() : ``}`,
                 monthJson : {1 : 'JAN', 2 : 'FEB', 3 : 'MAR', 4 : 'APR', 5 : 'MAY', 6 : 'JUNE', 7 : 'JULY', 8 : 'AUG', 9 : 'SEP', 10 : 'OCT', 11 : 'NOV', 12 : 'DEC', },
                 monthType : 'number'
            };
        },
        watch: {
            year(current, prev) {
                if (current > 9999) this.year = prev;
            },
        },
        methods: {
            blurFunc(){
                
            },
            updateDay() {
                if (parseInt(this.month) > 0  && parseInt(this.month) <= 12) {
                    this.monthType = 'text'
                    this.month = this.monthJson[parseInt(this.month)]
                }
                
                console.log('11111111111111',parseInt(this.day),(parseInt(this.day) > 0))
                 if(parseInt(this.day) > 0){
                    this.$parent.message = "";
                    if (!this.day.length || parseInt(this.day, 10) < 4) {
                        return;
                    }
                    if (this.showMonth) {
                        this.$refs.month.select();
                    }
                    else if (this.showYear){
                        //this.$refs.year.select();
                    } 
                }else{
                     this.$parent.message = "please select a valid date";
                }
               
            },
           
            updateMonth() {
                // console.log(this.monthJson, 'parseInt(this.month) ',parseInt(this.month) )
                if (parseInt(this.month) > 0  && parseInt(this.month) <= 12) {
                    this.$parent.message = "";
                    if (!this.month.length || parseInt(this.month, 10) < 2) {  return; }
                    if (this.showYear) this.$refs.year.select();
                } else {
                    this.$parent.message = "please select a valid month";
                }
                // console.log('parseInt(this.month, 10)===',parseInt(this.month, 10))
            },
            updateYear(){
                if (parseInt(this.month) > 0  && parseInt(this.month) <= 12) {
                    this.monthType = 'text'
                    this.month = this.monthJson[parseInt(this.month)]
                }

                if(parseInt(this.year) > 0){
                    this.$parent.message = "";
                     return;
                }else{
                     this.$parent.message = "please select a valid year";
                }
            },            
            updateValue() {
                 //const timestamp = `${this.year.padStart(4, 0)}-${this.month}-${this.day}`;
                const timestamp = `${this.year}-${this.month}-${this.day}`;


                console.log('timestamp===>',timestamp)
                if (Number.isNaN(timestamp)) return;
                this.$emit(`input`, timestamp);
            },
        },
    };
</script>

<style lang="scss">
    .FormDate {
        $spacing: 0.75em;
        display: inline-flex;
        position: relative;
        overflow: hidden;
        border: 1px solid #888;
        border-radius: 0.25em;
        // 1. Hide the spinner button in Chrome, Safari and Firefox.
        &__input {
            padding: $spacing;
            padding-right: $spacing / 2;
            padding-left: $spacing / 2;
            border: none;
            text-align: center;
            /* stylelint-disable-next-line property-no-vendor-prefix */
            -moz-appearance: textfield; // 1
            &::-webkit-inner-spin-button {
                display: none; // 1
            }
            &:first-child {
                padding-left: $spacing;
            }
            &:last-child {
                padding-right: $spacing;
            }
            &:focus {
                outline: none;
            }
            &--day,
            &--month {
                width: 3em;
            }
            &--year {
                width: 4em;
            }
        }
        &__divider {
            padding-top: $spacing;
            padding-bottom: $spacing;
            pointer-events: none;
        }
    }

    #ui-datepicker-div {
        display: none;
    }
</style>



// WEBPACK FOOTER //
// src/components/prism/Users/datePicker.vue